import {HotelRequestType} from 'types/Hotel'
import {MetaType} from 'types/Meta'
import {ProviderRequestType} from 'types/providerInfo'
import {urlParams} from 'utils/urlParams'

import {
  UrlCheckoutParamsType,
  UrlSearchParamsType
} from '@vio/core/src/utils/url/types/UrlParams'

import getHotelRequestParams from './mappers/getHotelRequestParams'
import metaParams from './mappers/meta'
import providerParams from './mappers/providerParams'
import searchWebsiteParams from './mappers/searchWebsiteParams'

export type URLParamsMapperType = {
  hotelRequestParams: HotelRequestType
  metaParams: MetaType
  params: UrlCheckoutParamsType
  providerParams: ProviderRequestType
  searchWebsiteParams: UrlSearchParamsType
}

const urlParamsMapper = (): URLParamsMapperType => {
  const params = urlParams()
  return {
    hotelRequestParams: getHotelRequestParams(params),
    searchWebsiteParams: searchWebsiteParams(params),
    metaParams: metaParams(params),
    providerParams: providerParams(params),
    params
  }
}

export default urlParamsMapper
